module.exports = __webpack_public_path__ + "static/media/image_48.73fb90e7.png";